import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';

@Injectable()
export class GroupsHelper {
    
    setUnixNameSections(group: any) {
        var arrUnixName = group.unixName.split("-");
        if (arrUnixName.length > 1) {
            group.unixNamePrefix = arrUnixName[0];
            group.unixNameSuffix = arrUnixName.slice(1).join('-');
        } else {
            group.unixNamePrefix = "";
            group.unixNameSuffix = arrUnixName[0];
        }
    }

    resetErrors() {
        return {
            unixName: {
                hasError: false,
            },
            name: {
                hasError: false,
            }
        };
    }

    addError(errors: any, fieldName: string, hasError: boolean = false, error: any = '') {
        const def = {
            hasError: false,
            error: ''
        };

        var current = _.get(
            errors, fieldName, def
        );

        current.hasError = hasError;
        current.error = error;

        errors[fieldName] = current;
        return errors;
    }

    validateGroup(group: any, errors: any) {

        // Set default validation status
        this.addError(errors, 'unixName');
        if (_.isEmpty(group.unixName)) {
            errors = this.addError(
                errors, 'unixName', true, 
                "The Group unix name cannot be empty"
            );
        } else {
            if (!(/^[a-z0-9_\.\-]+$/).test(group.unixName)) {
                errors = this.addError(
                    errors, 'unixName', true, 
                    "Only lowercase characters, numbers, '.', '_' and '-' characters are allowed"
                );
            }
        }

        // Set default validation status
        this.addError(errors, 'name');
        if (_.isEmpty(group.name)) {
            errors = this.addError(
                errors, 'name', true, 
                "The Group name cannot be empty"
            );
        }

        if (errors.unixName.hasError || errors.name.hasError) {
            return false;
        }

        return true;
    }
}
